import { KeyboardEvent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { trim } from 'lodash/fp';

import { Label } from '../../../../../../../common/labels/labelTypes';
import { updateLabel } from '../../../../../../../common/labels/labelActions';
import { LABEL_NAME_MAX_LENGTH } from '../../../../../../../common/labels/labelConstants';

type UseLabelNameEditorResult = {
    labelName: string;
    setLabelName: (name: string) => void;
    handleBlur: () => void;
    handleKeyDown: (e: KeyboardEvent) => void;
};

const cleanLabelName = (value: string): string => trim(value.substring(0, LABEL_NAME_MAX_LENGTH));

const useLabelNameEditor = (label: Label): UseLabelNameEditorResult => {
    const dispatch = useDispatch();
    const [labelName, setLabelName] = useState(label.name);

    useEffect(() => {
        setLabelName(label.name);
    }, [label.name]);

    const handleBlur = () => {
        const cleaned = cleanLabelName(labelName);
        const nextName = cleaned || label.name;

        setLabelName(nextName);

        if (nextName === label.name) return;

        dispatch(updateLabel(label._id, { name: nextName }));
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            (e.target as HTMLInputElement).blur();
        }
    };

    return { labelName, setLabelName, handleBlur, handleKeyDown };
};

export default useLabelNameEditor;
